module.exports = __webpack_public_path__ + "static/media/intro.759120bc.mp3";